import { GetDrawerAlerts, GetPageAlerts } from '@app/client/alerts/state/alerts-state.actions';
import { AlertSource } from '@app/client/alerts/state/alerts-state.models';

export function getActionFromSource(source: AlertSource): any {
  return source === 'drawer' ? GetDrawerAlerts : GetPageAlerts;
}
